import React, { useId } from 'react';
import { Box } from '@chakra-ui/react';

/** Orange sparkles mark used beside “About LocalCreators” and profile settings. */
const MarketplaceTokenIcon: React.FC<{ size?: number }> = ({ size = 12 }) => {
  const clipId = useId();

  return (
    <Box
      as="svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      flexShrink={0}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M5.5097 1.4082C5.53112 1.2935 5.59198 1.1899 5.68175 1.11536C5.77151 1.04081 5.88452 1 6.0012 1C6.11788 1 6.23089 1.04081 6.32065 1.11536C6.41041 1.1899 6.47127 1.2935 6.4927 1.4082L7.0182 4.1872C7.05552 4.38477 7.15154 4.56651 7.29371 4.70868C7.43589 4.85086 7.61762 4.94687 7.8152 4.9842L10.5942 5.5097C10.7089 5.53112 10.8125 5.59198 10.887 5.68175C10.9616 5.77151 11.0024 5.88452 11.0024 6.0012C11.0024 6.11788 10.9616 6.23089 10.887 6.32065C10.8125 6.41041 10.7089 6.47127 10.5942 6.4927L7.8152 7.0182C7.61762 7.05552 7.43589 7.15154 7.29371 7.29371C7.15154 7.43589 7.05552 7.61762 7.0182 7.8152L6.4927 10.5942C6.47127 10.7089 6.41041 10.8125 6.32065 10.887C6.23089 10.9616 6.11788 11.0024 6.0012 11.0024C5.88452 11.0024 5.77151 10.9616 5.68175 10.887C5.59198 10.8125 5.53112 10.7089 5.5097 10.5942L4.9842 7.8152C4.94687 7.61762 4.85086 7.43589 4.70868 7.29371C4.56651 7.15154 4.38477 7.05552 4.1872 7.0182L1.4082 6.4927C1.2935 6.47127 1.1899 6.41041 1.11536 6.32065C1.04081 6.23089 1 6.11788 1 6.0012C1 5.88452 1.04081 5.77151 1.11536 5.68175C1.1899 5.59198 1.2935 5.53112 1.4082 5.5097L4.1872 4.9842C4.38477 4.94687 4.56651 4.85086 4.70868 4.70868C4.85086 4.56651 4.94687 4.38477 4.9842 4.1872L5.5097 1.4082Z"
          stroke="#FF6900"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 1V2.99942"
          stroke="#FF6900"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9994 2H9"
          stroke="#FF6900"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.99971 10.9994C2.55183 10.9994 2.99942 10.5518 2.99942 9.99971C2.99942 9.44758 2.55183 9 1.99971 9C1.44758 9 1 9.44758 1 9.99971C1 10.5518 1.44758 10.9994 1.99971 10.9994Z"
          stroke="#FF6900"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </Box>
  );
};

export default MarketplaceTokenIcon;
